/** URL slug from project display name (must match API Project_model::name_to_slug). */
export function slugifyProjectName(name: string): string {
  const s = String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return s || 'project';
}

export function projectRouteSegment(project: { id?: number; name: string; project_key?: string | null }): string {
  const pid = Number(project.id);
  if (Number.isFinite(pid) && pid > 0) {
    return String(pid);
  }
  const key = String(project.project_key ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
  if (key.length >= 2) {
    return key;
  }
  return slugifyProjectName(project.name);
}

/** Build router link segments: ['/projects', slug-or-id, 'work', ...]. */
export function projectLink(
  project: { id?: number; name: string; project_key?: string | null },
  ...childSegments: string[]
): string[] {
  return ['/projects', projectRouteSegment(project), ...childSegments];
}

export function isNumericProjectRouteRef(ref: string): boolean {
  return /^\d+$/.test(String(ref ?? '').trim());
}
